import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import FileUpload from "@/components/FileUpload";
import { Download, Trash2, Plus, AlertCircle } from "lucide-react";

const CATEGORIES = ["membership", "affiliation", "rulebook", "examination", "technical", "brochure", "circular"];

export default function DownloadsManager() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", category: "membership", file_url: "" });
  const [err, setErr] = useState("");
  const refresh = () => api.get("/downloads").then((r) => setItems(r.data));
  useEffect(() => { refresh(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.file_url) { setErr("Please upload a file."); return; }
    setErr("");
    try {
      await api.post("/downloads", form);
      setForm({ title: "", category: "membership", file_url: "" });
      refresh();
    } catch (e2) { setErr(formatApiError(e2.response?.data?.detail) || e2.message); }
  };
  const remove = async (id) => { if (window.confirm("Remove this download?")) { await api.delete(`/downloads/${id}`); refresh(); } };
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <section className="bg-white border border-slate-200 rounded-md p-5">
      <div className="flex items-center gap-2"><Download className="h-5 w-5 text-nkf-red" /><h2 className="font-display text-xl text-nkf-blue">Downloads / Forms</h2></div>
      <form onSubmit={add} className="mt-4 grid grid-cols-1 md:grid-cols-12 gap-3">
        <input required value={form.title} onChange={(e) => set("title", e.target.value)} placeholder="Document title *" className="md:col-span-6 px-3 py-2.5 border border-slate-300 rounded-md text-sm" />
        <select value={form.category} onChange={(e) => set("category", e.target.value)} className="md:col-span-3 px-3 py-2.5 border border-slate-300 rounded-md text-sm bg-white">
          {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <button className="md:col-span-3 inline-flex items-center justify-center gap-1 bg-nkf-blue hover:bg-nkf-navy text-white text-xs font-bold uppercase tracking-widest px-4 py-2.5 rounded transition"><Plus className="h-3.5 w-3.5" /> Add</button>
        <div className="md:col-span-12">
          <FileUpload value={form.file_url} onChange={(v) => set("file_url", v)} label="Document File *" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
        </div>
      </form>
      {err && <div className="mt-3 flex items-start gap-2 bg-red-50 border border-red-200 text-red-700 p-2.5 rounded text-sm"><AlertCircle className="h-4 w-4 mt-0.5" /> {err}</div>}
      <div className="mt-4 divide-y divide-slate-100">
        {items.map((d) => (
          <div key={d.id} className="py-2.5 flex items-center justify-between gap-3">
            <div className="min-w-0">
              <div className="font-semibold text-nkf-blue truncate text-sm">{d.title}</div>
              <div className="text-[11px] uppercase tracking-widest text-slate-500">{d.category}</div>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              <a href={d.file_url} target="_blank" rel="noreferrer" className="text-xs text-nkf-blue hover:underline">View</a>
              <button onClick={() => remove(d.id)} className="text-red-600 hover:text-red-800"><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
        ))}
        {!items.length && <div className="py-6 text-center text-slate-400 text-sm">No documents yet.</div>}
      </div>
    </section>
  );
}
